import { observer } from 'mobx-react-lite'
import { pdfjs, Document, Page } from 'react-pdf'
import { useMemo } from 'react'
import { checkCDN } from 'shared/lib/checkCDN'
import { usePresentationModeContext } from 'widgets/PresentationMode'
import styles from './styles.module.scss'

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString()

export const PresentationPdf = observer(() => {
  const presentationStore = usePresentationModeContext()
  const { currentAttachment, imageControllerStore, setDisabledOverlayClick } = presentationStore
  const { page, scale, setNumPages } = imageControllerStore
  const url = currentAttachment?.source || currentAttachment?.source_short || ''
  const isCdnFile = checkCDN(url)
  const documentOptions = useMemo(
    () => (isCdnFile ? { withCredentials: true } : undefined),
    [isCdnFile]
  )

  if (!url) return null

  return (
    <div
      className={styles.wrap}
      onMouseEnter={() => setDisabledOverlayClick(true)}
      onMouseLeave={() => setDisabledOverlayClick(false)}
    >
      <Document
        file={url}
        options={documentOptions}
        onLoadSuccess={({ numPages }: { numPages: number }) => {
          setNumPages(numPages)
        }}
        loading={'Loading PDF...'}
        className={styles.content}
      >
        <Page
          pageNumber={page}
          scale={scale}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      </Document>
    </div>
  )
})
